import React from "react";

import { IntentMapperComponent, INTENT_MAPPER_DEFAULT_PROPS } from "../IntentMapperComponent";

import type { SelectIntentToClasses, SelectOptionProps, SelectProps } from "./Select.d";

export const SELECT_BLANK = {
    className: "",
    outerClassName: "",
};

export const SELECT_PRIMARY = {
    className: "select input",
    outerClassName: "flex items-center cursor-pointer",
};

export class Select extends IntentMapperComponent<SelectProps> {
    static defaultProps = {
        ...INTENT_MAPPER_DEFAULT_PROPS,
        type: "select",
    };
    classNameProps = Object.keys(SELECT_PRIMARY);
    intentToClasses: SelectIntentToClasses = {
        blank: SELECT_BLANK,
        primary: SELECT_PRIMARY,
    };

    render() {
        const { outerClassName, options = [], innerRef, ...rest } = this.getUpdatedProps();
        if (!options.length) {
            return null;
        }
        return (
            <div className={outerClassName}>
                <select {...rest} ref={innerRef}>
                    {options.map(({ label, ...props }: SelectOptionProps, index: number) => (
                        <option key={`${index}:${label}`} {...props}>
                            {label}
                        </option>
                    ))}
                </select>
            </div>
        );
    }
}

export default Select;
